// 常量配置
const global = {
  KEFUPHONE: '4000759009',
  GOODS_LIST_STYLE: 'goods-list-style',
  ACTIVE_LIST: [
    { phone: '恭喜尾号3987已激活额度，成功借款15000元' },
    { phone: '恭喜尾号7890获取提额特权，额度提升5000元' },
    { phone: '平台不收任何费用，近期诈骗案件高发，谨防上当受骗' },
    { phone: '恭喜尾号1880已激活额度，成功借款30000元' },
    { phone: '恭喜尾号1880已激活额度，成功借款9000元' },
    { phone: '恭喜尾号5290已激活额度，成功借款18000元' },
    { phone: '恭喜尾号6650获取提现特权，成功借款10000元' }
  ],
  MENU_PATH: [
    { path: '/', name: 'HOME', index: '0' },
    { path: '/integral', name: 'Integral', index: '1' },
    { path: '/member', name: 'Member', index: '2' },
    { path: '/my', name: 'My', index: '3' }
  ],
  MENU_SHOPPING_CART: '/shopping-cart', //购物车路由
  CUSTOMER_SERVICE: '',
  CUSTOMER_SERVICE_SHA1_KEY: '5d2773e276029c698b3fb2c1bcba3151',
  CREDIT_SCENE_CASH: 'CASH', // 授信场景值-备用金
  CREDIT_SCENE_CONSUME: 'CONSUME', // 授信场景值-消费
  CREDIT_SCENE_DOWN_PAYMENT: 'DOWN_PAYMENT', // 暴享付

  AD_POSITION_HOME_POPUP: 'HOME_POPUP', // 首页弹框
  AD_POSITION_HOME_BANNAR: 'HOME_BANNAR', // 首页bannar
  AD_POSITION_HOME_LOAN: 'HOME_LOAN', // 	首页光速借
  AD_POSITION_HOME_INSTALLMENT: 'HOME_INSTALLMENT', // 	首页暴享付
  AD_POSITION_HOME_MEMBER: 'HOME_MEMBER', // 首页会员
  AD_POSITION_HOME_FINANCE: 'HOME_FINANCE', // 首页金融
  AD_POSITION_HOME_ACTIVITY: 'HOME_ACTIVITY', // 首页活动
  AD_POSITION_HOME_MOFANG: 'HOME_MOFANG', // 首页魔方
  AD_POSITION_HOME_SALES: 'HOME_SALES', // 首页卖场
  AD_POSITION_HOME_WATERFALL: 'HOME_WATERFALL', //首页瀑布流
  AD_POSITION_FI_HOME_BANNER: 'FI_HOME_BANNER', // 店铺页顶部横幅广告
  AD_POSITION_FI_ACTIVITY: 'FI_ACTIVITY', // 店铺页活动广告
  AD_POSITION_GOODS_CATEGORY: 'GOODS_CATEGORY', // 商品分类
  AD_POSITION_MY_MEMBER: 'MY_MEMBER', // 我的会员
  AD_POSITION_MY_ADVERTISEMENT: 'MY_ADVERTISEMENT', // 我的广告位
  AD_POSITION_LOAN_FINISH: 'LOAN_FINISH', // 借款结果页
  AD_POSITION_LOAN_ACTIVITY: 'LOAN_ACTIVITY', // 光速借-活动
  AD_POSITION_PHONE_SKU: 'PHONE_SKU', // 手机充值SKU位置 (暂时停用)
  AD_POSITION_PHONE: 'PHONE', // 手机充值 (暂时停用)
  AD_POSITION_INSTALLMENT_PRODUCT: 'INSTALLMENT_PRODUCT', // 购物页顶部 (暂时停用)
  AD_POSITION_GXF_AUDIT: 'GXF_AUDIT', // 暴享付审核中
  AD_POSITION_GXF_AUDIT_POPUP: 'GXF_AUDIT_POPUP', // 暴享付审核中-弹框
  AD_POSITION_GOODS_REGION_HOT_AD: 'HOME_HOT_AD', // 商品热推广告
  AD_POSITION_GOODS_REGION_WATERFALL_AD: 'HOME_WATERFALL_AD', // 商品瀑布流广告

  ICON_FUN_APP_HOME: 'APP_HOME', // 首页icon
  ICON_FUN_MY: 'MY', // 我的页面icon
  ICON_FUN_MY_QUOTA: 'MY_QUOTA', // 我的额度icon
  ICON_FUN_SUSPENSION: 'SUSPENSION', // 悬浮按钮icon
  ICON_FUN_SHOP_HOME: 'SHOP_HOME', // 商城页icon  (暂时停用)

  GOODS_REGION_FOLLOW: 'FOLLOW', // 猜你喜欢
  GOODS_REGION_RECOMMEND: 'RECOMMEND', // 热门推荐
  GOODS_REGION_PLATFORM_RECOMMEND: 'PLATFORM_RECOMMEND', // 平台推荐
  GOODS_REGION_MEMBER_DISCOUNTS: 'MEMBER_DISCOUNTS', // 会员特惠
  GOODS_REGION_CULLING_CONVERT: 'POINT_CULLING_CONVERT', // 精选兑换
  GOODS_REGION_DOWN_PAYMENT: 'DOWN_PAYMENT', // 暴享付商品
  GOODS_REGION_DOWN_PAYMENT_MAIN: 'DOWN_PAYMENT_MAIN', // 暴享付商品主推商品
  GOODS_REGION_HOT_LIST: 'HOT_LIST', // 热卖榜单
  GOODS_REGION_NEW: 'NEW', // 商品推荐区域  (暂时停用)

  PRODUCT_REGION_HOT: 'HOT', // 热门推荐
  PRODUCT_REGION_GUIDE_JOIN: 'GUIDE_JOIN_PRODUCT', // 优质专区

  USER_FLOW_BANKCARD: 'BANKCARD', //待绑定银行卡
  USER_FLOW_IDCARD: 'IDCARD', //待实名
  USER_FLOW_FINISH: 'FINISH', //完成授信
  USER_FLOW_INFO: 'INFO', //需要录入基础信息
  PAY_TYPE_BILLPAY: 'BILLPAY', //支付类型，账单支付
  PAY_TYPE_ALIPAY: 'ALIPAY', //支付类型，支付宝支付
  PAY_TYPE_ALIPAYHBFQ: 'ALIPAYHBFQ', //支付宝花呗分期
  PAY_TYPE_WECHATPAY: 'WECHAT', //支付类型，微信支付
  PAY_TYPE_QUICKPAY: 'QUICKPAY', //快捷支付
  PAY_TYPE_PAYLATER: 'PAYLATER', //先享后付
  PAY_TYPE_DOWN_PAYMENT: 'DOWN_PAYMENT', // 首付支付
  CASHIER_SPEND_RECHARGE: 'SPEND_RECHARGE', // 话费充值
  CASHIER_EQUITY: 'EQUITY', // 权益类
  CASHIER_VIP_BUY: 'VIP_BUY', // 会员购买
  CASHIER_VIP_LOAN_BUY: 'VIP_LOAN_BUY', // 备用金会员购买
  CASHIER_VIP_DISCOUNT: 'VIP_DISCOUNT', // 省钱卡会员购买
  CASHIER_GOODS_ORDER: 'GOODS_ORDER', // 商品订单
  LOCAL_CREDIT_SCENE: 'creditScene', // 授信场景
  APP_VERSION_VERIFY: 'VERIFY', //审核版
  APP_VERSION_OFFICIAL: 'OFFICIAL', //正式版
  APP_VERSION_CHANNEL: 'CHANNEL', //渠道版
  ADDRESS_CHECKED: 'address-checked',
  PARAM_ORDERCONFIRM: 'param-orderConfirm',
  PARAM_AFTERSALES: 'param-afterSales',
  GOODS_DETAIL_ADDRESS: 'goods-detail-address',

  EDUCATION_OPTIONS: [
    // 学历
    { text: '初中', value: '1' },
    { text: '高中', value: '2' },
    { text: '中专', value: '3' },
    { text: '专科', value: '4' },
    { text: '本科', value: '5' },
    { text: '硕士', value: '6' },
    { text: '博士及以上', value: '7' }
  ],
  COMPANY_POSITION_OPTIONS: [
    // 职业
    { text: '上班族', value: '1' },
    { text: '企业主', value: '2' },
    { text: '个体户', value: '3' },
    { text: '自由职业', value: '4' }
  ],
  OCCUPATION_OPTIONS: [
    // 职业
    { text: '上班族', value: '1' },
    { text: '企业主', value: '2' },
    { text: '个体户/个体工商户', value: '3' },
    { text: '自由职业', value: '4' },
    { text: '农民，工人', value: '5' },
    { text: '教师', value: '6' },
    { text: '学生', value: '7' },
    { text: '其他', value: '8' },
    { text: '公务员/事业单位', value: '9' },
    { text: '国家机关企业负责人', value: '11' },
    { text: '专业技术人员', value: '12' },
    { text: '办事人员和有关人员', value: '13' },
    { text: '商业服务人员', value: '14' },
    { text: '农林牧渔水利业人员', value: '15' },
    { text: '生产&运输&设备操作及相关人员', value: '16' },
    { text: '军人', value: '17' },
    { text: '其他从业人员', value: '18' }
  ],
  LIVE_STATUS_OPTIONS: [
    // 住房状况
    { text: '自置商品房', value: '1' },
    { text: '租房', value: '2' },
    { text: '集体宿舍', value: '3' },
    { text: '其他', value: '4' }
  ],
  MARRIAGE_OPTIONS: [
    // 婚姻状况
    { text: '未婚', value: '1' },
    { text: '已婚', value: '2' }
  ],
  INCOME_OPTIONS: [
    { text: '3500以下', value: '1' },
    { text: '3500-6000', value: '2' },
    { text: '6000-10000', value: '3' },
    { text: '10000-20000', value: '4' },
    { text: '20000以上', value: '5' }
  ],
  RELATIONSHOP1_OPTIONS: [
    // 亲属关系
    { text: '父母', value: 'parent' },
    { text: '配偶', value: 'spouse' },
    { text: '子女', value: 'children' },
    { text: '兄弟姐妹', value: 'brothers' },
    { text: '其他', value: 'other' }
  ],
  RELATIONSHOP2_OPTIONS: [
    // 其他关系
    { text: '同事', value: 'colleague' },
    { text: '朋友', value: 'friend' },
    { text: '其他', value: 'classmate' }
  ],
  PERIOS_OPTIONS: [
    // 贷款时间
    { text: '1个月', value: '1' },
    { text: '3个月', value: '3' },
    { text: '6个月', value: '6' },
    { text: '12个月', value: '12' },
    { text: '24个月', value: '24' }
  ],
  JOB_OPTIONS: [
    // 职业
    { text: '农/林/畜/渔/水利业', value: '1' },
    { text: '信息传输/软件/信息技术服务业', value: '2' },
    { text: '金融业', value: '3' },
    { text: '制造业', value: '4' },
    { text: '房地产', value: '5' },
    { text: '批发/零售业', value: '6' },
    { text: '教育', value: '7' },
    { text: '文化/体育/娱乐业', value: '8' },
    { text: '卫生/社会工作', value: '9' },
    { text: '电力/热力/燃气/水生产/供应业', value: '10' },
    { text: '居民服务/修理/其他服务业', value: '11' },
    { text: '公共管理/社会保障/社会组织/国际组织', value: '12' },
    { text: '住宿/餐饮业', value: '13' },
    { text: '采矿业', value: '14' },
    { text: '建筑业', value: '15' },
    { text: '交通运输/仓储业/邮政业', value: '16' },
    { text: '租赁/商务服务业', value: '17' },
    { text: '其他', value: '99' }
  ],
  LOANUSAGE_OPTIONS: [
    // 贷款用途
    { text: '个人消费', value: '个人消费' }
  ],
  LOANUSAGE_OPTIONS2: [
    // 贷款用途
    { text: '个人日常消费', value: '个人日常消费' },
    { text: '装修', value: '装修' },
    { text: '教育', value: '教育' },
    { text: '手机数码', value: '手机数码' },
    { text: '电器', value: '电器' },
    { text: '医疗', value: '医疗' },
    { text: '租房', value: '租房' },
    { text: '家具家居', value: '家具家居' },
    { text: '旅游', value: '旅游' },
    { text: '婚庆', value: '婚庆' }
  ],
  GOODS_ORDER_STATUS: {
    PAYING: '待付款',
    VERIFY: '待审核',
    WAIT_DELIVER: '待发货',
    WAIT_RECEIVING: '待收货',
    WAIT_COMMENT: '待评论',
    FINISHED: '已完成',
    CANCEL: '已取消',
    PAIED: '已支付',
    REFUND: '已退款'
  },
  ORDER_STATUS: {
    REPAY: '待付款',
    PAYING: '支付中',
    PAIED: '已付款',
    VERIFY: '人工审核',
    FAILED: '订单失败',
    PART: '订单部分完成',
    FINISH: '订单全部完成',
    REFUND_VERIFY: '退款审核',
    VERIFY_NOPASS: '审核不通过',
    REFUND: '已退款',
    REFUND_FAILED: '退款失败',
    REFUNDING: '退款中'
  },
  MEMBER_ORDER_STATUS: {
    REPAY: '待付款',
    PAYING: '支付中',
    PAIED: '已激活',
    VERIFY: '人工审核',
    FAILED: '订单失败',
    PART: '订单部分完成',
    FINISH: '订单全部完成',
    REFUND_VERIFY: '退款审核',
    VERIFY_NOPASS: '审核不通过',
    REFUND: '已退款',
    REFUND_FAILED: '退款失败',
    REFUNDING: '退款中'
  },
  ORDER_CHL_STATUS: {
    NON: '服务商未处理',
    PROCESSING: '服务商处理中',
    FINISH: '完成',
    PART: '部分完成',
    FAILED: '服务商处理失败'
  },
  ORDER_PAY_TYPE: {
    WECHATPAY: '微信支付',
    ALIPAY: '支付宝支付',
    ALIPAYHBFQ: '花呗分期',
    UNIONPAY: '云闪付',
    QUICKPAY: '银行卡支付',
    BILLPAY: '订单分期',
    PAYLATER: '先享后付'
  },
  // todo==需要修改
  IOS_DOWN_LINK: 'https://apk.huabaozx.com/__UNI__237ADC2_0521111900.apk',
  ANDRIOD_DOWN_LINK: 'https://apk.huabaozx.com/__UNI__237ADC2_0521111900.apk',
  ANDRIOD_DOWN_LINK_CHANNEL: 'https://apk.huabaozx.com/__UNI__237ADC2_0521111900.apk'
}
export default global
